// Helpers de presentación (rediseño 2026-07-02)

// meta = "14 min · canal AutomatizApp" → { duration: "14 min", author: "canal AutomatizApp" }
export const splitMeta = (meta = "") => {
  const [duration, author] = meta.split("·").map((s) => s.trim());
  return { duration: duration || "", author: author || "" };
};

const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const formatWhen = (iso) => {
  const d = new Date(iso);
  const now = new Date();
  const time = d.toLocaleTimeString("es-ES", { hour: "numeric", minute: "2-digit" });
  if (isSameDay(d, now)) return `Hoy, ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameDay(d, yesterday)) return `Ayer, ${time}`;
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

export const dateGroup = (iso) => {
  const d = new Date(iso);
  const now = new Date();
  if (isSameDay(d, now)) return "Hoy";
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameDay(d, yesterday)) return "Ayer";
  if (now - d < 7 * 86400000) return "Últimos 7 días";
  return "Anteriores";
};

export const GROUP_ORDER = ["Hoy", "Ayer", "Últimos 7 días", "Anteriores"];

export const STATUS_DOT = {
  inbox: "bg-stone-400",
  pendiente: "bg-amber-600",
  importante: "bg-teal-600",
  aplicado: "bg-green-600",
  archivado: "bg-stone-300",
};
